<div class="fonb-shell">

  <div class="fonb-header">
    <div>
      <h2 class="fonb-header__title">{{ 'FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.TITLE' | translate }}</h2>
      <p class="fonb-header__meta">{{ 'FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="fonb-resources">
    <a
      *ngFor="let link of links"
      class="fonb-resource"
      [href]="link.url"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div class="fonb-resource__body">
        <span class="fonb-resource__issuer" *ngIf="link.issuer">
          {{ 'FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.ISSUERS.' + link.issuer | translate }}
        </span>
        <h4 class="fonb-resource__title">
          {{ 'FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.LINKS.' + link.i18nKey | translate }}
        </h4>
        <span class="fonb-resource__host">{{ hostOf(link.url) }}</span>
      </div>
      <i class="pi pi-external-link fonb-resource__arrow" aria-hidden="true"></i>
    </a>
  </div>

</div>
